import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() iconPosition?: 'left' | 'right';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() layout: 'hug' | 'fill' = 'hug';
  @Input() type: 'primary' | 'secondary' = 'primary';
  @Input() backgroundColor?: string;
  @Output() clickEvent = new EventEmitter<void>();

  themeService = inject(ThemeService);

  get hasOutline(): boolean {
    return this.type === 'primary' && this.themeService.buttonConfig().primary.outline;
  }

  get iconPos(): string {
    return this.iconPosition ?? this.themeService.buttonConfig().iconPosition;
  }

  get backgroundStyle(): Record<string, string> {
    if (!this.backgroundColor) {
      return {};
    }
    return { 'background-color': `var(${this.backgroundColor})` };
  }

  onClick(): void {
    if (!this.disabled) {
      this.clickEvent.emit();
    }
  }
}
